module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/General/Trash-5fa4c511a3f2d8002c06a95ace4f7699.svg";